module.exports = __webpack_public_path__ + "static/media/bg_card_2_wap.5c3e3c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/bg_card_2_wap.png
// module id = 133
// module chunks = 0